import { useState } from "react";

import styled from "styled-components";





const Container = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 20px 0px;
  border: 1px solid #eee;
  border-top: none;
  border-bottom: none;
`;
const Div = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 15px;
`;

export const Button2 = styled.button`
  padding: 10px 20px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-color: ${(props) => (props.ativo ? '#fff' : '#E5F7EE')};
  color: ${(props) => (props.ativo ? '#008000' : '#008000')};
  border-radius: 6px;
  transition: all 0.3s ease;

  width: 250px;
  

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px #076333;
  }

  @media (max-width: 768px) {
    flex: 0 0 48%; // 2 colunas com pequeno espaçamento
  }

  @media (max-width: 480px) {
    flex: 0 0 48%; // 1 coluna total em telas muito pequenas
  }
`;


const Grid = ({ onAbrirTipo, onAbrirSubTipo, onAbrirItemSubTipo }) => {








  return (
    <Container>
      <Div>
        <Button2 width="10%" onClick={onAbrirTipo}>
          Tipo de Chamado
        </Button2>
        <Button2 width="10%" onClick={onAbrirSubTipo}>
          Assunto
        </Button2>

        <Button2 width="10%" onClick={onAbrirItemSubTipo}>
          Detalhamento do Problema
        </Button2>
      </Div>

    </Container>
  );
};


export default Grid;
